import i18n from '@/i18n'

import telegramIcon from "@/assets/quiz/telegramIcon.svg";
import whatsAppIcon from "@/assets/quiz/whatsAppIcon.svg";
import viberIcon from "@/assets/quiz/viberIcon.svg";
import weChatIcon from "@/assets/quiz/weChatIcon.svg";
import messengerIcon from "@/assets/quiz/messengerIcon.svg";
import instagramIcon from "@/assets/quiz/instagramIcon.svg";
import xIcon from "@/assets/quiz/xIcon.svg";

export const MESSENGERS = [
  { name: i18n.t('quiz.messenger.telegram'), icon: telegramIcon },
  { name: i18n.t('quiz.messenger.whatsapp'), icon: whatsAppIcon },
  { name: i18n.t('quiz.messenger.viber'), icon: viberIcon },
  { name: i18n.t('quiz.messenger.wechat'), icon: weChatIcon },
  { name: i18n.t('quiz.messenger.messenger'), icon: messengerIcon },
  { name: i18n.t('quiz.messenger.instagram'), icon: instagramIcon },
  { name: i18n.t('quiz.messenger.x'), icon: xIcon },
];

export const TELEGRAM_MESSENGER = 'Telegram';

export const ADDITIONAL_QUIZ_STEP = {
  amplitudeName: 'quiz additional',
  active: false,
  question: 'new.step2.title',
  questionStepIcon: 'telegramQuestion.svg',
  description1: 'new.step2.description1',
  index: 2,
  answers: [
    {
      text: 'new.step2.answ10',
      textDescription: 'new.step2.addtext10',
      value: 'housing_reserv'
    },
    {
      text: 'new.step2.answ11',
      textDescription: 'new.step2.addtext11',
      value: 'education'
    },
    {
      text: 'new.step2.answ12',
      textDescription: 'new.step2.addtext12',
      value: 'hr'
    },
    {
      text: 'new.step2.answ13',
      textDescription: 'new.step2.addtext13',
      value: 'e-commerce'
    },
    {
      text: 'new.step2.answ14',
      value: 'gaming'
    },
    {
      text: 'new.step2.answ15',
      value: 'another'
    }
  ]
};

export const QUESTIONS_LIST = [
  {
    amplitudeName: 'quiz user anti',
    active: true,
    question: 'new.step1.title',
    questionStepIcon: 'commentQuestion.svg',
    description1: 'new.step1.description1',
    description2: 'new.step1.description2',
    emoji: 'smiling.png',
    index: 0,
    answers: [
      {
        emoji: 'checkIcon.png',
        text: 'new.step1.answ1',
        value: 'yes'
      },
      {
        emoji: 'close.png',
        text: 'new.step1.answ2',
        value: 'no'
      }
    ]
  },
  {
    amplitudeName: 'quiz audience',
    active: false,
    question: 'new.step2.title',
    questionStepIcon: 'telegramQuestion.svg',
    description1: 'new.step2.description1',
    index: 1,
    answers: [
      {
        text: 'new.step2.answ1',
        value: 'arbitrage_fb'
      },
      {
        text: 'new.step2.answ2',
        value: 'arbitrage_gg'
      },
      {
        text: 'new.step2.answ3',
        textDescription: 'new.step2.addtext3',
        value: 'arbitrage_etc'
      },
      {
        text: 'new.step2.answ4',
        textDescription: 'new.step2.addtext4',
        value: 'onlyfans'
      },
      {
        text: 'new.step2.answ5',
        textDescription: 'new.step2.addtext5',
        value: 'crypto'
      },
      {
        text: 'new.step2.answ6',
        textDescription: 'new.step2.addtext6',
        value: 'adult'
      },
      {
        text: 'new.step2.answ7',
        textDescription: 'new.step2.addtext7',
        value: 'context_ads'
      },
      {
        text: 'new.step2.answ8',
        textDescription: 'new.step2.addtext8',
        value: 'marketplaces'
      },
      {
        text: 'new.step2.answ9',
        textDescription: 'new.step2.addtext9',
        value: 'betting'
      },
      {
        text: 'new.step2.more',
        value: 'other'
      }
    ]
  },
  {
    amplitudeName: 'quiz bp count',
    active: false,
    question: 'new.step3.title',
    description1: 'new.step3.description1',
    questionStepIcon: 'browserProfilesIcon.svg',
    index: 2,
    answers: [
      {
        emoji: 'eyes.png',
        text: 'new.step3.answ1',
        value: 'free'
      },
      {
        emoji: 'peaceSign.png',
        text: 'new.step3.answ2',
        value: '10-100'
      },
      {
        emoji: 'handshake.png',
        text: 'new.step3.answ3',
        value: '100-300'
      },
      {
        emoji: 'iLoveYouSign.png',
        text: 'new.step3.answ4',
        value: '300-500'
      },
      {
        emoji: 'muscle.png',
        text: 'new.step3.answ5',
        value: '500-1000'
      },
      {
        emoji: 'cool.png',
        text: 'new.step3.answ6',
        value: '1000+'
      },
      {
        emoji: 'thinkingFace.png',
        text: 'new.step3.answ7',
        value: 'do not know yet'
      }
    ]
  },
  {
    amplitudeName: 'quiz users count',
    active: false,
    question: 'new.step4.title',
    description1: 'new.step4.description1',
    questionStepIcon: 'usersQuestion.svg',
    index: 3,
    answers: [
      {
        emoji: 'peaceSign.png',
        text: 'new.step4.answ1',
        value: '1'
      },
      {
        emoji: 'handshake.png',
        text: 'new.step4.answ2',
        value: '2'
      },
      {
        emoji: 'iLoveYouSign.png',
        text: 'new.step4.answ3',
        value: '3-6'
      },
      {
        emoji: 'muscle.png',
        text: 'new.step4.answ4',
        value: '6-15'
      },
      {
        emoji: 'cool.png',
        text: 'new.step4.answ5',
        value: '15-50'
      },
      {
        emoji: 'crown.png',
        text: 'new.step4.answ6',
        value: '50+'
      },
      {
        emoji: 'thinkingFace.png',
        text: 'new.step4.answ7',
        value: 'do not know yet'
      }
    ]
  },
  {
    amplitudeName: 'quiz contact',
    active: false,
    question: 'new.step5.title',
    description1: 'new.step5.description1',
    description2: 'new.step5.description2',
    emoji: 'foldedHands.png',
    questionStepIcon: 'heartsQuestion.svg',
    index: 4,
    answers: []
  }
];
